module.exports = ['$scope', '$templateCache', 'ngDroUAA',
    function ($scope, $templateCache, ngDroUAA) {

        /*
         * Config
         */
        $templateCache.put('profile-form.html', require('./tabs/profile-form.html'));
        $templateCache.put('password-form.html', require('./tabs/password-form.html'));
        $templateCache.put('thumb-form.html', require('./tabs/thumb-form.html'));


        $scope.person = {};
        $scope.backupPerson = {};


        ngDroUAA.Profile.get().then(function (response) {
            $scope.person = response.data;
            angular.copy($scope.person, $scope.backupPerson);
            // ora che ho l'id scarico l'immagine
            
            ngDroUAA.Profile.getBadge($scope.person.id).then(function (response) {
                $scope.person.thumb = {};
                $scope.person.thumb.data = response.data;
                $scope.person.thumb.type = response.headers('Content-Type');
            });
        });


        /*
         * Methods
         */
        
        // mi serve nel template per disabilitare i campi                                                   TODO: PERMESSI?
        $scope.hasPerms = function () {
            //return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;               
            return true;
        };
        
        /**
         * Questa funzione setta nello scope l'oggetto 
         * form presente nella finestra modale.
         * Questa funzione è chiamata da ng-init="setFormScope(this)".
         * @param {type} scope
         */
        $scope.setFormScope = function (scope) {
            this.formScope = scope;
        };
  
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/profile/profileDetail/profileDetailCtrl.js
// module id = 410
// module chunks = 0